export default __webpack_public_path__ + "static/Retul-lab-shoe-4d5e1b844701953caf1df05939d3ea2f.jpg";